<script setup>
import { defineProps } from 'vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'

defineProps({ anchor: String })
</script>

<template>
  <doc-section title="Introduction" :anchor="anchor">
    <template v-slot:left>
      <p>
        The Webscout REST API offers a straightforward, efficient way to interact
        with our threat-intelligence services programmatically. Each endpoint maps
        to a unique URL that you send HTTP requests to in order to retrieve data.
      </p>
      <p>
        All endpoints share the same base URL: <strong>https://api.webscout.io</strong>.
        For brevity this prefix is omitted from the paths throughout this reference, 
        e.g. <code>/query/ip/:ip</code> means
        <code>https://api.webscout.io/query/ip/:ip</code>.
      </p>
      <p>
        Responses are JSON and follow a consistent envelope (see
        <a href="#response-format">Response format</a>). Most endpoints require
        authentication with an API key (see
        <a href="#authentication">Authentication</a>).
      </p>
    </template>

    <template v-slot:right>
      <code-block title="Base URL" text>
        https://api.webscout.io
      </code-block>

      <code-block title="/query/ip/:ip" method="GET" text>
        https://api.webscout.io/query/ip/8.8.8.8?apikey={YOUR_APIKEY}
      </code-block>
    </template>
  </doc-section>
</template>
